import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  Renderer2,
  Self,
  SimpleChange,
  ViewChild,
} from '@angular/core';
import { NgControl } from '@angular/forms';

import intlTelInput from 'intl-tel-input';

import { RtInput } from './../../utils/rt-input';

@Component({
  selector: 'rt-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.less'],
})
export class RtPhoneInputComponent extends RtInput<string> implements OnInit {
  @Input() public countryCode: string;
  @Input() public placeholder: string;

  @Output() public valueChange: EventEmitter<string> = new EventEmitter();

  @ViewChild('input', { read: ElementRef, static: true }) public input: NgControl;

  public intl: any;

  constructor(
    elementRef: ElementRef,
    renderer2: Renderer2,
    @Optional()
    @Self()
    ngControl: NgControl,
    protected cdRef: ChangeDetectorRef,
  ) {
    super(elementRef, renderer2, ngControl, cdRef);
  }

  public ngOnChanges({ countryCode }: { countryCode: SimpleChange }): void {
    if (this.intl && countryCode) this.intl.setCountry(countryCode.currentValue);
  }

  public ngOnInit(): void {
    this.intl = intlTelInput(this.nativeInputElement, {
      initialCountry: this.countryCode || 'gb',
      nationalMode: false,
      preferredCountries: ['nl', 'gb', 'de', 'us'],
      autoPlaceholder: undefined,
      autoHideDialCode: false,
      utilsScript: 'assets/scripts/utils.js',
    });
  }
}
